export default __webpack_public_path__ + "8b9504064385b28255189486cb01f760.png";